import { DELETE_NOTIFICATION_URL, GET_NOTIFICATION_LIST_URL, MARK_ALL_AS_READ_NOTIFICATION_URL, MARK_AS_READ_NOTIFICATION_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getNotificationList = (per_page, offset, page) => onResponse => {
    if (!per_page)
        per_page = '';
    if (!offset)
        offset = '';
    try {
        axiosInstance.get(GET_NOTIFICATION_LIST_URL + '?per_page=' + per_page + '&offset=' + offset + '&page=' + page)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const markAsReadNotification = (id) => onResponse => {
    try {
        axiosInstance.post(MARK_AS_READ_NOTIFICATION_URL, id)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const markAllAsReadNotification = () => onResponse => {
    try {
        axiosInstance.post(MARK_ALL_AS_READ_NOTIFICATION_URL)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const deleteNotification = (id) => onResponse => {
    try {
        axiosInstance.post(DELETE_NOTIFICATION_URL, id)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};